import React, { useEffect, useRef, useState }   from "react";
import ReactTooltip                             from 'react-tooltip';
import {Link}                                   from "react-router-dom";
import {Shimmer}                                from "../shimmer/shimmer";

import "./template.scss";
const URL_PRODUCT_OPTIONS = '/product-options/'

export const WIDTH_TEMPLATE = 204

export const Template = ({item, agentHasYearlySubscription, paywallModal, agentBenefits, templateDownloadModal, userLevels}) => {
    const [isVisible, setIsVisible] = useState(false)
    const [imageLoaded, setImageLoaded] = useState([false, false])
    const [imageVisible, setImageVisible] = useState([true, true])
    const ref = useRef(null)
    const template = item

    const hasFirstImage = template.thumbnail_1?.startsWith('http')
    const hasSecondImage = template.thumbnail_2?.startsWith('http')
    const classImage = hasFirstImage && hasSecondImage ? 'dual' : 'single'
    const visibility = (template.finished_width && template.finished_height) ? '' : 'hidden'

    const currentSearch = window.location.search;

    const templateName = template.relation_type == "custom" ? (
        template.related_name
    ) : (
        template.template_name
    )
    const linkUrl = template.relation_type == "custom" ? (
        `${URL_PRODUCT_OPTIONS}${template.template_id}/${template.related_id}`
    ) : (
        getRedirectTo({template, agentBenefits, currentSearch, agentHasYearlySubscription})
    )

    const templateShrapnel = template.id.split('_')
    let labelPrimary = 'Front '
    const idPrimary = templateShrapnel[0]
    let relationType = ''
    let idRelated = ''
    if(templateShrapnel.length > 1) {
        relationType = String(template.relation_type.charAt(0).toUpperCase()) + String(template.relation_type.slice(1)) + ' '
        idRelated = templateShrapnel[1]

        switch(template.relation_type) {
            case 'Variation':
            case 'variation':
                labelPrimary = 'Master '
                break

            case 'Custom':
            case 'custom':
                labelPrimary = 'Source '
                break

            default:
            case 'none':
                break
        }
    }

    const handleImageLoad = (index) => {
        setImageLoaded(prev => {
            const updated = [...prev]
            updated[index] = true
            return updated
        })
    }

    const handleImageError = (index) => {
        setImageVisible(prev => {
            const updated = [...prev]
            updated[index] = false
            return updated
        })
    }

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if(entry.isIntersecting) {
                    setIsVisible(true)
                    observer.disconnect()
                }
            }
        )

        if(ref.current) {
            observer.observe(ref.current)
        }

        return ()  => observer.disconnect()

    }, [])

    return (
        <div
            ref={ref}
            className="template-dznts586"
            style={{
                width: `${WIDTH_TEMPLATE}px`,
            }}
            xd-qa-type="card"
            xd-qa-name={idPrimary}
        >
        {
            isVisible &&
            <Link
                to={linkUrl}
                className="template-container"
                onClick={(e) => {
                    if(item.category_type === "subscriber" && !agentHasYearlySubscription && !allowBenefits({agentBenefits, template})) {
                        paywallModal.show();
                    } else {
                        templateDownloadModal.show({
                            allowSocialShare: item.allow_social_sharing,
                            templateDownloadUrl: item.download_image_url,
                            itemId: item.id,
                            templateId: item.template_id,
                            templateName: item.template_name,
                        })
                    }
                }}
            >
            {
                userLevels?.internalUser &&
                <>
                    <p
                        className="template-id"
                        xd-qa-type="label"
                        xd-qa-name={idPrimary}
                    >{`${labelPrimary}${idPrimary}`}</p>
                    {
                        relationType &&
                        <p
                            className="template-id relation"
                            xd-qa-type="label"
                            xd-qa-name={idRelated}
                        >{`${relationType}${idRelated}`}</p>
                    }
                </>
            }
            {
                (hasFirstImage || hasSecondImage) &&
                <>
                    {
                        (!imageLoaded[0] && !imageLoaded[1]) &&
                        <Shimmer name="image-container" />
                    }
                    <div className="image-container">
                        {
                            (hasFirstImage && imageVisible[0]) &&
                            <img
                                src={template.thumbnail_1}
                                alt={templateName}
                                className={classImage}
                                onLoad={() => handleImageLoad(0)}
                                onError={() => handleImageError(0)}
                                style={{display: imageLoaded[0] ? 'block' : 'none'}}
                            />
                        }
                        {
                            (hasSecondImage && imageVisible[1]) &&
                            <img
                                src={template.thumbnail_2}
                                alt={templateName}
                                className={classImage}
                                onLoad={() => handleImageLoad(1)}
                                onError={() => handleImageError(1)}
                                style={{display: imageLoaded[1] ? 'block' : 'none'}}
                            />
                        }
                    </div>
                </>
            }
            <div className="details">
                <p className="template-name">{templateName}</p>
                <ReactTooltip  id={`style-name-${template.id}`} place="top" delayShow={500}/>
                <p
                    className="style-name"
                    xd-qa-type="label"
                    xd-qa-name="Template Style name"
                    data-tip={template.style_name}
                    data-for={`style-name-${template.id}`}
                >
                    {template.style_name}
                </p>
                <p className={`finshed-size ${visibility}`}>{`${template.finished_width}" x ${template.finished_height}"`}</p>
                {
                    template.proof_engine_type === 0 &&
                    <div className="icon" xd-qa-type="icon" xd-qa-name="Smart Template Icon">
                        <img alt="Smart Template" src="/next_images/icons/SmartTemplateIcon.svg"/>
                    </div>
                }
            </div>
            {
                item.out_of_stock && item.allow_back_order == false &&
                <img
                    className="out-of-stock-overlay"
                    src={require("../../../../../../public/assets/out-of-stock-overlay.svg")}
                    xd-qa-type="image"
                    xd-qa-name="Out of Stock Image"
                />
            }
            {
                item.category_type === "subscriber" &&
                <div
                    className="subscriber"
                    style={{
                        backgroundImage: `url("/next_images/XDPlusTileBanner.svg")`,
                    }}
                />
            }
            </Link>
        }
        </div>
    )
}

const getRedirectTo = ({template, agentBenefits, currentSearch, agentHasYearlySubscription}) => {
    const hasPopup = (template.no_proof_popup_modal !== undefined && template.no_proof_popup_modal);
    const isLockedSubscriber = template.category_type === "subscriber" && (!agentHasYearlySubscription && !allowBenefits({agentBenefits, template}));
    if (hasPopup || isLockedSubscriber) {
        return currentSearch;
    }

    return `${URL_PRODUCT_OPTIONS}${template.template_id}`;
}

const allowBenefits = ({agentBenefits, template}) => {
    const benefitIds = template.subscription_benefits && template.subscription_benefits
        .split(',')
        .map(id => parseInt(id.trim(), 10));

        return benefitIds && agentBenefits && agentBenefits.some(id => benefitIds.includes(id));
}